<template>
    <b-card class="empty-dashed-card">
        <div class="d-table w-100">
            <div
                    class="card-text d-table-cell-middle-center"
                    :style="cardTextStyle"
            >
                <div class="text-gray-900 font-weight-bold">
                    <h2
                            v-if="title"
                            class="dashed-card-title"
                    >
                        {{ title }}
                    </h2>
                    <span
                            v-if="icon"
                            :class="{
                                'card-icon': true,
                                [icon]: true
                            }"
                    ></span>
                    <span
                            v-if="text"
                            class="link"
                    >
                        <span>{{ text }}</span>
                    </span>
                </div>
                <div
                        v-if="additionalText"
                        class="additional-text"
                >
                    <span>{{ additionalText }}</span>
                </div>
            </div>
        </div>
        <slot></slot>
    </b-card>
</template>
<script>
    import './EmptyDashedCard.scss';

    export default {
        name: 'Empty',
        props: {
            icon: {
                type: String,
                required: false,
            },
            title: {
                type: String,
                required: false,
                default: ''
            },
            text: {
                type: String,
                required: false,
                default: ''
            },
            additionalText: {
                type: String,
                required: false,
                default: ''
            },
            height: {
                type: [
                    Number,
                    String
                ],
                required: false,
                default: 'auto'
            },
        },
        computed: {
            cardTextStyle: function () {
                let height = this.height;
                if (typeof height === 'number') {
                    height = parseFloat(height) + 'px';
                }
                return {
                    height: height
                };
            }
        }
    };
</script>
